import { render, staticRenderFns } from "./logisticsStatus.vue?vue&type=template&id=7e0888df"
import script from "./logisticsStatus.vue?vue&type=script&lang=js"
export * from "./logisticsStatus.vue?vue&type=script&lang=js"
import style0 from "./logisticsStatus.vue?vue&type=style&index=0&id=7e0888df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports